<template>
  <div>
    <v-dialog v-model="value" max-width="70%" persistent>
        <v-card class="elevation-16 mx-auto">
            <v-carousel height="500">
                <!-- <v-carousel-item v-for="file in files" :key="file._id">
                    <v-sheet :color="color" height="100%" tile>
                        <v-row class="fill-height" align="center" justify="center">
                            <div class="display-3">
                                Slide {{ i + 1 }}
                            </div>
                        </v-row>
                    </v-sheet>
                </v-carousel-item> -->
                <v-carousel-item 
                    v-for="file in editedItem.files" 
                    :key="file._id">
                    <v-sheet height="100%" tile>
                        <v-row class="fill-height" align="center" justify="center">
                            <v-img :src="baseAttach + file._id" max-height="500" contain></v-img>
                        </v-row>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>
            <v-card-title class="headline" primary-title>
                <span >{{ editedItem.name}}</span>
            </v-card-title>

            <v-card-text>
                <!-- <span >{{ editedItem.description}}</span> -->
                <div v-html='editedItem.description'/>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-between">
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="closeDialog">{{ $t('common.close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
    export default {
        name: 'present-idea-request',

        components: {
        },

        data: ()=> ({
            baseAttach: process.env.VUE_APP_BASE_ATTACH,
        }),

        props: {
            value: Boolean,
            editedItem: Object,
        },

        methods: {
            closeDialog() {
                this.dialog = false;
                this.$emit('closeDialog', this.dialog);
            },
        },
    }
</script>
